<template>
  <div class="versioninfo" aria-hidden="true">
    <span class="versioninfo-text">v{{ version }}</span>
  </div>
</template>

<script setup>

import { version } from '@/../package.json'


</script>

<style scoped>
.versioninfo {
  text-align: center;
  color: #9ca3af;
  font-size: 10px !important;
}
.versioninfo-text {
  color: #9ca3af;
  font-size: 10px !important;
}

/* Beim Drucken ausblenden */
@media print {
  .versioninfo {
    display: none;
  }
}
</style>
